export default __webpack_public_path__ + "static/media/voice-instruction.c3b77849.svg";